import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { InputComponent, MakeProvider } from '../input-component';
import { DateTime } from 'luxon';
import { Utilities } from 'src/app/core/helper/util';


@Component({
  selector: 'app-datetime-input',
  templateUrl: './datetime-input.component.html',
  styleUrls: ['./datetime-input.component.scss'],
  providers: [MakeProvider(DateTimeInputComponent)]
})
export class DateTimeInputComponent extends InputComponent implements OnInit, OnChanges {

  @Input() type = 'datetime';
  @Input() minTime: string;
  @Input() minDate: string;

  inputTime: string;
  inputDate: string;


  constructor() { super(); }

  ngOnInit() {
    setTimeout(() => {
      this.initDateTimeValues();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initDateTimeValues();
  }

  inputChange() {
    if (Utilities.stringEmpty(this.inputDate)) {
      this.value = undefined;
      this.inputDate = undefined;
      this.inputTime = undefined;
    } else {
      const changedDate = new Date(`${this.inputDate}T${Utilities.stringEmpty(this.inputTime) ? '00:00' : this.inputTime}`);
      this.value = changedDate.toISOString();
    }
  }

  protected updateValue(): void {
    this.initDateTimeValues();
  }

  private async initDateTimeValues() {
    //let newDate = new Date();

    if (this.value) {
      const newDate = new Date(this.value);

      const dateM = DateTime.fromISO(newDate.toISOString());

      this.inputDate = dateM.toFormat('yyyy-MM-dd');

      if (this.value) {
        this.inputTime = dateM.toFormat('HH:mm');
      } else {
        this.inputTime = dateM.toFormat('HH:00');
      }
    }

  }


}
